import { GridCellParams, GridRenderCellParams } from '@microservices/wiskey-react-table-component'

import { getColumnParameterStyles } from '@pages/ConfiguredEntity/helpers'

import { cellRenderer, getColumnParametersFromArray } from '@helpers'
import {
  STYLED_COLUMN_HEADER_CLASSNAME,
  STYLED_COLUMN_TEXT_CLASSNAME,
  TIME_LINE_COLUMN_WIDTH,
} from '@constants'
import { ColumnParametersType, ConfiguredColumn, TimeLineGridColumn } from '@types'

import { isBottomPinnedTotalRow } from './isBottomPinnedTotalRow'
import { isGroupTitleRow } from './isGroupTitleRow'

export const getColumnProperties = (
  column: ConfiguredColumn,
  additionalProps: Partial<TimeLineGridColumn> = {}
) => {
  const columnParameters = getColumnLocalParameters({
    useParameters: column.useLocalParameters,
    parameters: column.parameters,
  })

  const columnClassNames = {
    header: `${STYLED_COLUMN_HEADER_CLASSNAME}-TIME_LINE-${column.code}_field`,
    text: `${STYLED_COLUMN_TEXT_CLASSNAME}-TIME_LINE-${column.code}_field`,
  }

  return {
    style: {
      [`.${columnClassNames.header}`]: columnParameters.headerStyles,
      [`.${columnClassNames.text}`]: columnParameters.cellStyles,
    },
    column: {
      field: column.code,
      headerName: column.title,
      code: column.code,
      width: column.width || TIME_LINE_COLUMN_WIDTH,
      sortKey: column.columnToSort,
      sortable: false,
      cellClassName: (params: GridCellParams) => {
        return isBottomPinnedTotalRow(params.id as string) || isGroupTitleRow(params.id as string)
          ? ''
          : columnClassNames.text
      },
      headerClassName: columnClassNames.header,
      align: columnParameters.align,
      headerAlign: columnParameters.headerAlign,
      renderCell: (params: GridRenderCellParams) => {
        return cellRenderer({ ...column, code: column.value }, params, false)
      },
      ...additionalProps,
    },
  }
}

const getColumnLocalParameters = (data: {
  parameters?: ColumnParametersType
  useParameters?: boolean
}) => {
  const { parameters, useParameters } = data

  if (!useParameters || !parameters?.length) {
    return {}
  }

  const { headerProperties, textProperties } = getColumnParametersFromArray(parameters)

  const { transformedParams: columnHeaderParams, styles: columnHeaderStyles } =
    getColumnParameterStyles(headerProperties)
  const { transformedParams: columnTextParams, styles: columnTextStyles } =
    getColumnParameterStyles(textProperties)

  return {
    align: columnTextParams?.alignment,
    headerAlign: columnHeaderParams?.alignment,
    headerStyles: columnHeaderStyles,
    cellStyles: columnTextStyles,
  }
}
